import { render } from "./MegacentroView.vue?vue&type=template&id=09483751"
import script from "./MegacentroView.vue?vue&type=script&lang=js"
export * from "./MegacentroView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__